import {
  PostOfficeProvider as PostOfficeProviderBase,
  PostOfficeContextConfig,
  PostOfficeEnvironmentConfig,
} from '@atlassian/post-office-placement-remote';
import { getEnvironment, LOCAL, PRODUCTION } from '@atlassian/temp-shared';
import React, { PropsWithChildren, useEffect, useMemo } from 'react';

const derivePostOfficeEnvironment = () => {
  const microsEnv = getEnvironment() ?? LOCAL;
  if (microsEnv === PRODUCTION) return 'production';
  return microsEnv;
};

export const PostOfficeProvider: React.FC<PropsWithChildren<{}>> = ({ children }) => {
  const context = useMemo<PostOfficeContextConfig>(() => {
    return {
      current: {
        product: 'cssXp',
        locale: 'en',
        subproduct: 'partnerPurchasingCenter',
      },
    };
  }, []);

  const environment = useMemo<PostOfficeEnvironmentConfig>(() => {
    return {
      env: derivePostOfficeEnvironment(),
    };
  }, []);

  return (
    <PostOfficeProviderBase environment={environment} context={context}>
      {children}
    </PostOfficeProviderBase>
  );
};
